export const NEXT_LOCALE = 'NEXT_LOCALE' as const;
export const USER_ACCESS_TOKEN = 'user_access_token' as const;
export const USER_AGENT = 'user_agent' as const;
export const DEV_MODE_DOMEN_CHECK_PERMISSION = 'dev_mode_domen_check_permission' as const;
